import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=79ef6de8&scoped=true&"
import script from "./GeneralTab.vue?vue&type=script&lang=js&"
export * from "./GeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=79ef6de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef6de8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ef6de8')) {
      api.createRecord('79ef6de8', component.options)
    } else {
      api.reload('79ef6de8', component.options)
    }
    module.hot.accept("./GeneralTab.vue?vue&type=template&id=79ef6de8&scoped=true&", function () {
      api.rerender('79ef6de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Tabs/GeneralTab.vue"
export default component.exports